$(function() {
   var min = 1;
   var max = 10;
   min = Math.ceil(min);
   max = Math.floor(max);
   var  r =  Math.floor(Math.random() * (max - min + 1)) + min;
   var inc = '0' ;
    var mytimeAgo = ['1', '2', '3', '4', '5','0', '-1', '-2', '-3', '-4', '-5'];
   var randomlytimeAgo='';
   var currentmytimeAgo='';
   var plus = ['1', '3', '1'];
   var randomlytimeAgo='';
   var currentmytimeAgo='';
   var range='';
    setInterval(function(){  
      randomlytimeAgo =  Math.floor(Math.random() * mytimeAgo.length); 
      currentmytimeAgo = mytimeAgo[randomlytimeAgo];    
      r = parseInt(r)+parseInt(currentmytimeAgo) ;     
      if(r <=10 ){     
         range =  Math.floor(Math.random() * plus.length);         
         var final =  plus[range];      
        r=r+final;
      }
      if(r > 15){     
          range =  Math.floor(Math.random() * plus.length);         
         var final =  plus[range];        
          r=r-final;
      }
      if( r > 0)
      {
      $("#dynamic_counter").html(r + ""); 
      }
  }, 5000);               
});